<template>
  <div>
    <base-horizontal-bar-chart
      v-show="!printable || (!imgData && printable)"
      :height="height ? height : null"
      :chart-data="getChartData"
      :options="getChartOptions"
      @chartCreated="setChart"
    />
    <img :height="height ? height : 200" :src="imgData" v-show="printable && imgData">
  </div>
</template>

<script>
import barChartMixin from './mixins/barChartMixin';
import BaseHorizontalBarChart from './base/BaseHorizontalBarChart';

export default {
  name: 'HorizontalBarChart',
  components: {
    BaseHorizontalBarChart,
  },
  data: () => ({
    chart: null,
    imgData: null,
  }),
  props: {
    height: {
      type: Number,
    },
    printable: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [barChartMixin],
  methods: {
    setChart(chart) {
      this.chart = chart;
    },
    animationComplete() {
      if (!this.chart || !this.printable) {
        return;
      }
      this.imgData = this.chart.toBase64Image();
    },
  },
};
</script>



// WEBPACK FOOTER //
// HorizontalBarChart.vue?21203b10